export const timelineDateFormat = 'MM/DD/YYYY'
export const timelineDateShortYearFormat = 'MM/DD/YY'
export const timelineDateShortFormat = 'M/D/YY'
export const timelineShortMonthFullYearFormat = 'M/D/YYYY'
export const longFormatDate = 'MMMM D, YYYY'
export const timelineDateFormatShort = 'M/D/YY'
export const timelineTimeFormat = 'hh:mm A'
export const timelineFullDateFormatWitTime =
  timelineDateFormat + ' ' + timelineTimeFormat

export const timelineQuarterFormat = 'YYYY-[Q]Q'
export const timelineMonthFormat = 'YYYY-MM'
export const timelineYearFormat = 'YYYY'
export const timelineMonthYearFormat = 'MMMM YYYY'
